import { render, staticRenderFns } from "./Sns.vue?vue&type=template&id=c1c9e38e&scoped=true&lang=pug&"
import script from "./Sns.vue?vue&type=script&lang=js&"
export * from "./Sns.vue?vue&type=script&lang=js&"
import style0 from "./Sns.vue?vue&type=style&index=0&id=c1c9e38e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c1c9e38e",
  null
  
)

export default component.exports